import StartEventHook from './StartEventHook'
import { bidderForCode } from '../utils'
import FillManager from '../FillManager'
import { AvantisFillMethod } from '../fillers/AvantisFillMethod'

export default class AvantisHook extends StartEventHook {
  constructor () {
    super('AvantisHook')
  }

  async run (remoteConfig) {
    let bidder

    const avantis = bidderForCode('avantis', remoteConfig.bidders(), true)
    const floater = bidderForCode('avantis_floater', remoteConfig.bidders(), true)
    const docked = bidderForCode('avantis_docked', remoteConfig.bidders(), true)

    if (avantis) { // normal in place
      bidder = avantis
      bidder.params.tagId = 2
    } else if (floater) {
      bidder = floater
      bidder.params.tagId = 1
    } else if (docked) {
      bidder = docked
      bidder.params.tagId = 3
    } else {
      // no avantis enabled
      return
    }

    FillManager.register(new AvantisFillMethod(bidder))
  }
}
